import React from 'react';
import type { PopulatedSection } from 'root/apiTypes';
import { classes } from './Sections.st.css';
import { Section } from 'root/components/Menus/Section/Section';
import { dataHooks } from 'root/dataHooks';

export const Sections = ({ menuTitleId, sections }: { menuTitleId: string; sections: PopulatedSection[] }) => {
  return (
    <div
      aria-labelledby={menuTitleId}
      className={classes.sectionsContainer}
      data-hook={dataHooks.sections.container}
      role="list"
    >
      {sections.map((section) => (
        <Section key={section.id} section={section} />
      ))}
    </div>
  );
};
